import { imageApi, queryApi } from 'lib/api';
import { Response, ServiceMenuParam, ServiceMenuResponse } from 'lib/api/type';
import { ImageSetParam, ImageSetResponse, ItemParam } from './type';

export const getServiceMenu = (
  data: ServiceMenuParam
): Promise<ServiceMenuResponse> => queryApi('common/service/menu', data);

export const setImageMint = (data: ImageSetParam): Promise<ImageSetResponse> =>
  imageApi('image/mint/set', data);

export const setItemSet = (data: ItemParam): Promise<Response> =>
  queryApi('mint/item/set', data);

export const setItemCheck = (data: ItemParam): Promise<Response> =>
  queryApi('mint/item/check', data);
